// Small yes/no dialog for actions that throw work away — currently resigning
// a game in progress. Deliberately plain: a heading, a sentence of
// consequence, and up to three buttons.

import { installModalBehavior } from "./modal";

export interface ConfirmModalOpts {
  title: string;
  body: string;
  confirmLabel: string;
  onConfirm: () => void;
  /** Optional third choice shown between confirm and cancel. */
  secondaryLabel?: string;
  onSecondary?: () => void;
  cancelLabel?: string;
  /** Tints the confirm button as destructive. */
  danger?: boolean;
}

export function openConfirmModal(overlayContainer: HTMLElement, opts: ConfirmModalOpts): void {
  const backdrop = document.createElement("div");
  backdrop.className = "modal-backdrop";
  const modal = document.createElement("div");
  modal.className = "modal confirm-modal";

  const h = document.createElement("h2");
  h.textContent = opts.title;
  const p = document.createElement("p");
  p.textContent = opts.body;
  const actions = document.createElement("div");
  actions.className = "actions";

  modal.append(h, p, actions);
  backdrop.appendChild(modal);
  overlayContainer.appendChild(backdrop);

  const close = (): void => backdrop.remove();

  const confirm = document.createElement("button");
  confirm.className = opts.danger ? "primary danger" : "primary";
  confirm.textContent = opts.confirmLabel;
  confirm.addEventListener("click", () => {
    close();
    opts.onConfirm();
  });
  actions.appendChild(confirm);

  if (opts.secondaryLabel && opts.onSecondary) {
    const secondary = document.createElement("button");
    secondary.textContent = opts.secondaryLabel;
    secondary.addEventListener("click", () => {
      close();
      opts.onSecondary?.();
    });
    actions.appendChild(secondary);
  }

  const cancel = document.createElement("button");
  cancel.textContent = opts.cancelLabel ?? "Cancel";
  cancel.addEventListener("click", close);
  actions.appendChild(cancel);

  installModalBehavior(backdrop, { onRequestClose: close, closeOnBackdrop: true });
  // Focus lands on Cancel, not the destructive default: a stray Enter must not
  // throw the game away.
  cancel.focus();
}
